var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrengthenValuationsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "StrengthenValuations_icon_svg__a",
    d: "M0 60h64.068V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.95 28.475c0 15.726-12.75 28.474-28.475 28.474C12.748 56.95 0 44.201 0 28.475 0 12.748 12.748 0 28.475 0 44.2 0 56.949 12.748 56.949 28.475",
    fill: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCC0C4",
    d: "M63.05 58.983H6.103v-46.78h3.05l3.051-4.067h16.272l3.05 4.067h31.526z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.119 57.966h54.915V13.22H31.017l-3.05-4.067H12.711L9.66 13.22H7.119v44.746zM64.068 60H5.085V11.186h3.56l3.05-4.067h17.288l3.05 4.067h32.035V60z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "StrengthenValuations_icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#StrengthenValuations_icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#StrengthenValuations_icon_svg__b)",
    d: "M10.17 54.915h48.813V16.271H10.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.186 53.898h46.78v-36.61h-46.78v36.61zm-2.033 2.034H60V15.254H9.153v40.678z",
    fill: "#000",
    mask: "url(#StrengthenValuations_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#StrengthenValuations_icon_svg__b)",
    d: "M13.22 21.356h42.712v-2.034H13.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    mask: "url(#StrengthenValuations_icon_svg__b)",
    d: "M13.22 13.22h14.238v-2.034H13.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#StrengthenValuations_icon_svg__b)",
    d: "M45.763 49.83h5.084V26.44h-5.084z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.78 48.814h3.05V27.458h-3.05v21.356zm-2.034 2.033h7.118V25.424h-7.118v25.423z",
    fill: "#EE4900",
    mask: "url(#StrengthenValuations_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#StrengthenValuations_icon_svg__b)",
    d: "M36.61 49.83h5.085V31.526H36.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.627 48.814h3.051V32.542h-3.05v16.272zm-2.034 2.033h7.119V30.508h-7.119v20.34z",
    fill: "#EE4900",
    mask: "url(#StrengthenValuations_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#StrengthenValuations_icon_svg__b)",
    d: "M27.458 49.83h5.084V37.628h-5.084z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.475 48.814h3.05v-10.17h-3.05v10.17zm-2.034 2.033h7.118V36.61h-7.118v14.237z",
    fill: "#EE4900",
    mask: "url(#StrengthenValuations_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#StrengthenValuations_icon_svg__b)",
    d: "M18.305 49.83h5.085v-8.135h-5.085z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.322 48.814h3.05v-6.102h-3.05v6.102zm-2.034 2.033h7.119V40.678h-7.119v10.17z",
    fill: "#EE4900",
    mask: "url(#StrengthenValuations_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#StrengthenValuations_icon_svg__b)",
    d: "M13.22 50.847h42.712v-2.033H13.22z"
  }))));
}
export default SvgStrengthenValuationsIcon;